'use client';

import { useQuery } from '@tanstack/react-query';
import { storyKeys } from '../queryKeys';
import { getStories, type GetStoriesResult } from '../actions/getStories';

export function useStories(
  familyId: string | null | undefined,
  params?: { page?: number; pageSize?: number; status?: string; onlyFavorites?: boolean }
) {
  return useQuery<GetStoriesResult>({
    queryKey: [
      ...storyKeys.list(familyId ?? ''),
      params?.page,
      params?.pageSize,
      params?.status,
      params?.onlyFavorites ?? false,
    ],
    queryFn: () => getStories(params),
    enabled: !!familyId,
  });
}
